import React from "react";
import Stack from "@mui/material/Stack";
import {ProactiveResponseButtons} from "../ProactiveResponseButtons";
import styles from "../Utilities/styles.module.css"

export const ProactiveDropdownForm = ({
    selectedCriteria,
    setSelectedCriteria,
    setLiked,
    setReplied,
    setNoEngagement,
    setFollowed,
    setConverted,
    setFollowUpSent,
    setConvertedAfterFollowUpSent,
    setHasAdditionalOrders,
    setOrderedWithin5Days,
    setOrderedRecommendedCategory,
    setOrderedRecommendedProduct,
    setUsedDiscount,
    setUsedExactDiscountCode,
    setLastTouch,
    pageFilter
}) => {

    return (
        <Stack direction={'row'} >
            <div className={`${styles["ml15"]}`}>
                <ProactiveResponseButtons
                    selectedCriteria={selectedCriteria}
                    setSelectedCriteria={setSelectedCriteria}
                    setLiked={setLiked}
                    setReplied={setReplied}
                    setNoEngagement={setNoEngagement}
                    setFollowed={setFollowed}
                    setConverted={setConverted}
                    setFollowUpSent={setFollowUpSent}
                    setConvertedAfterFollowUpSent={setConvertedAfterFollowUpSent}
                    setHasAdditionalOrders={setHasAdditionalOrders}
                    setOrderedWithin5Days={setOrderedWithin5Days}
                    setOrderedRecommendedCategory={setOrderedRecommendedCategory}
                    setOrderedRecommendedProduct={setOrderedRecommendedProduct}
                    setUsedDiscount={setUsedDiscount}
                    setUsedExactDiscountCode={setUsedExactDiscountCode}
                    setLastTouch={setLastTouch}
                    pageFilter={pageFilter}
                />
            </div>
        </Stack>
    )
}